var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5C7 3.10218 7.15804 2.72064 7.43934 2.43934C7.72064 2.15804 8.10218 2 8.5 2H12.379C12.7767 2.00035 13.158 2.15862 13.439 2.44L16.561 5.56C16.7004 5.69948 16.8109 5.86506 16.8862 6.04729C16.9616 6.22952 17.0002 6.42482 17 6.622V12.5C17 12.8978 16.842 13.2794 16.5607 13.5607C16.2794 13.842 15.8978 14 15.5 14H14.5V10.621C14.4998 9.82542 14.1836 9.06248 13.621 8.5L10.5 5.379C9.93752 4.81635 9.17458 4.50017 8.379 4.5H7V3.5Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6C4.10218 6 3.72064 6.15804 3.43934 6.43934C3.15804 6.72065 3 7.10218 3 7.5V16.5C3 16.8978 3.15804 17.2794 3.43934 17.5607C3.72064 17.842 4.10218 18 4.5 18H11.5C11.8978 18 12.2794 17.842 12.5607 17.5607C12.842 17.2794 13 16.8978 13 16.5V10.621C12.9997 10.2233 12.8414 9.84204 12.56 9.561L9.44 6.439C9.30052 6.29962 9.13494 6.1891 8.95271 6.11377C8.77048 6.03844 8.57518 5.99978 8.378 6H4.5Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.601f9d5fc992d0e47a01ab1b8d022918.svg";
export { ForwardRef as ReactComponent };